import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type {
  FullReport, IRIMReportParamsDTO, Report, RIMReportBody, RIMReportParams,
} from '@/api/routes/reports/types';

import { generateReport } from './actionCreators';

interface InitialState {
  body: RIMReportBody | null,
  sign: string | null,
  params: RIMReportParams | null,
  type: string | null,
  isLoading: boolean,
  error: string,
  enabled: boolean,
  generate_on_demand: boolean,
}

const initialState: InitialState = {
  body: null,
  sign: null,
  params: null,
  type: null,
  isLoading: false,
  error: '',
  enabled: true,
  generate_on_demand: false,
};

export const generatedReportSlice = createSlice({
  name: 'generatedReport',
  initialState,
  reducers: {
    setReportLoading: (state) => {
      state.isLoading = true;
    },
    setReportError: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setReportData: (state, action: PayloadAction<Required<Report<RIMReportParams, RIMReportBody>>>) => {
      state.isLoading = false;
      state.error = '';
      state.body = action.payload.body;
      state.sign = action.payload.sign;
      state.params = action.payload.params;
      state.type = action.payload.type_id;
      state.enabled = action.payload.enabled;
      state.generate_on_demand = action.payload.generate_on_demand;
    },
    setManageCharts: (state, action: PayloadAction<IRIMReportParamsDTO>) => {
      if (state.params) {
        state.params.include_avg_online_by_day = action.payload.include_avg_online_by_day ?? false;
        state.params.include_device_count_by_day = action.payload.include_device_count_by_day ?? false;
      }
    },
  },
  extraReducers: {
    [generateReport.fulfilled.type]: (state, action: PayloadAction<FullReport<RIMReportBody, RIMReportParams>>) => {
      state.isLoading = false;
      state.error = '';
      state.body = action.payload.body;
      state.sign = action.payload.sign;
      state.params = action.payload.params;
      state.type = action.payload.type;
    },
    [generateReport.pending.type]: (state) => {
      state.isLoading = true;
    },
    [generateReport.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  setReportData,
  setReportError,
  setReportLoading,
  setManageCharts,
} = generatedReportSlice.actions;
export default generatedReportSlice.reducer;
